import React from 'react';
import styled from 'styled-components';
import { margin } from '../styles/mixins';
const StyledSpacer = styled.div.withConfig({
  displayName: "Spacer__StyledSpacer",
  componentId: "bywv8e-0"
})(["", ";", ";display:", ";"], x => x.vertical ? null : margin(x.amount, 'r'), x => x.vertical ? margin(x.amount, 'b') : null, x => x.vertical ? 'block' : 'inline-block');
export const Spacer = ({
  amount = 1,
  vertical = false
}) => /*#__PURE__*/React.createElement(StyledSpacer, {
  amount: amount,
  vertical: vertical
});